// angular
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { FormBuilder, Validators } from '@angular/forms';
// services
import { TranslationsService } from './translations.service';
import { AuthService } from '../core/auth.service';
import { BaseService } from '../shared/base.service';
// others
import { BaseComponent } from '../shared/base.component';
import { AppService } from '../app.service';
import { TranslationModel } from './translations.model';
import { DialogComponent } from '../dialog/dialog.component';

@Component({
    selector: 'translations-component',
    templateUrl: './translations.component.html',
    styleUrls: ['./translations.component.scss'],
    providers: [TranslationsService, BaseService]
})
export class TranslationsComponent extends BaseComponent implements OnInit {
    keyword = '';
    id: number;
    items: Object[] = [];
    url = 'translations';
    components = [{
        'id': 1,
        'name': 'Authentication'
    }, {
        'id': 2,
        'name': 'User Management'
    }, {
        'id': 3,
        'name': 'Permission Management'
    }, {
        'id': 4,
        'name': 'Feeling List Management'
    }, {
        'id': 5,
        'name': 'Clinic and Division Management'
    }, {
        'id': 6,
        'name': 'Filter'
    }, {
        'id': 7,
        'name': 'Patient Management'
    }, {
        'id': 8,
        'name': 'Profile Management'
    }, {
        'id': 9,
        'name': 'Feeling and Selection Rating'
    }, {
        'id': 10,
        'name': 'Inventory Creation'
    }];
    className = 'modal';

    // define what table columns to display [column key, label, css class]
    readonly tableColumns = [
        // ['component', 'Component', 'col-xs-4', 'text'],
        // ['text',  'Label', 'col-xs-4', 'text'],
        ['en_GB', 'English', 'col-xs-3', 'text'],
        ['de_CH', 'German', 'col-xs-3', 'text'],
        ['fr_FR', 'French', 'col-xs-3', 'text'],
        ['it_IT', 'Italian', 'col-xs-3', 'text']
    ];

    @ViewChild('inputFile') inputFile: ElementRef;
    @ViewChild('dialog', { static: false }) dialog: DialogComponent;

    constructor(public authService: AuthService,
        public router: Router,
        public baseService: BaseService,
        public appService: AppService,
        public route: ActivatedRoute,
        public fb: FormBuilder,
        public translationsService: TranslationsService) {
        super(authService, router, baseService, appService);
    }

    ngOnInit() {
        this.searchInfo = new TranslationModel();
        super.ngOnInit();

        this.isUpdatable = this.authService.isAuthorised('translations.update');

        this.getItems();
    }

    exportTranslation() {
        this.token = this.authService.user['token'];
        window.location.href = this.authService.baseUrl + 'translations/export' + '?token=' + this.token;
    }

    importTranslation(fileInput: any) {
        // create FormData
        const formData: FormData = new FormData();
        formData.append('blob', fileInput.target.files[0]);
        
        this.isLoading = true;
        this.translationsService.importFile(formData).subscribe(
            response => {
                this.isLoading = false;
                const alert = this.dialog.openAlert({icon: 'fas fa-exclamation-triangle'});
                alert.showAlert('The file was processed successfully. All matching rows were updated.');
            },
            err => {
                const alert = this.dialog.openAlert({icon: 'fas fa-exclamation-triangle'});
                alert.showAlert('The import of the file failed');
                this.isLoading = false;
            });
        this.inputFile.nativeElement.value = '';
    }

    createTranslation() {
        this.isLoading = true;
        this.translationsService.generateFile().subscribe(data => {
            this.isLoading = false;
            this.items = data['items'];
            this.getItems();
        });
    }

    openFormModal(params: Object) {
        this.initForm(params);

        if (params['url'] && params['url'] !== "") {
            this.url = params['url'];
        }

        this.translationsService.read(params['id'])
            .subscribe(
                response => {
                    let translation = response['item'];
                    let form = {};

                    let disabled = params['action'] === 'read' ? true : false;

                    for (let column in translation) {
                        if (translation.hasOwnProperty(column)) {
                            form[column] = { value: translation[column], disabled: disabled };
                        }
                    }

                    if (this.form != null) {
                        this.form.reset(form);
                    } else {
                        this.form = this.fb.group(form);
                    }

                    this.showModal();
                });
    }
}
